import {AreaOfInterest} from "../../profile/domain/area-of-interest";
import {Address} from "../../profile/domain/address";
import {Phone} from "../../profile/domain/phone";
import {Entity} from "../../core/commons/entity";
import {Ministry} from "../../profile/domain/ministry/ministry";

export class Abogado implements Entity {
    id: number;
    email: string;
    firstname: string;
    lastname: string;
    dni: string = "-";
    birthDate: Date;
    profilePhoto: string;
    backgroundPhoto: string;
    areaOfInterest: AreaOfInterest;
    ministry: Ministry;
    workAddress: Address;
    workPhone: Phone;


    constructor(value: Object = {}) {
        Object.assign(this, value);
        this.birthDate = new Date(this.birthDate);
        this.workAddress = this.workAddress ? new Address(this.workAddress) : null;
        this.ministry = this.ministry ? new Ministry(this.ministry): null;
        this.areaOfInterest = this.areaOfInterest ? new AreaOfInterest(this.areaOfInterest): null;
        if(this.workPhone) this.workPhone = new Phone(this.workPhone);
    }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/domain/abogado.ts